/* eslint-disable */
import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  DateTime: string;
  DateTimeOffset: string;
  Decimal: string;
  Milliseconds: string;
  Seconds: string;
};

export type AppointmentDetailType = {
  readonly __typename?: 'AppointmentDetailType';
  readonly id: Scalars['String'];
  readonly startTime: Scalars['String'];
};

export type AppointmentInfoType = {
  readonly __typename?: 'AppointmentInfoType';
  readonly durationInMinutes: Scalars['Int'];
  readonly id: Scalars['String'];
  readonly patientWaitTimeInSeconds: Scalars['Int'];
  readonly serviceType: Scalars['String'];
  readonly startTime: Scalars['String'];
  readonly status?: Maybe<AppointmentStatus>;
};

export enum AppointmentStatus {
  Unknown = 'UNKNOWN',
  Proposed = 'PROPOSED',
  Pending = 'PENDING',
  Booked = 'BOOKED',
  Arrived = 'ARRIVED',
  Fulfilled = 'FULFILLED',
  Cancelled = 'CANCELLED',
  NoShow = 'NO_SHOW',
  EnteredInError = 'ENTERED_IN_ERROR',
  CheckedIn = 'CHECKED_IN',
  Waitlist = 'WAITLIST'
}





export type LaunchAppContinueAadType = {
  readonly __typename?: 'LaunchAppContinueAadType';
  readonly sessionId: Scalars['String'];
};

export type LaunchAppContinueLoginType = {
  readonly __typename?: 'LaunchAppContinueLoginType';
  readonly m365LoginUrl: Scalars['String'];
};

export type LaunchAppContinueType = {
  readonly __typename?: 'LaunchAppContinueType';
  readonly sessionId: Scalars['String'];
};

export type LaunchAppContinueTypeUnionResult = LaunchAppContinueType | LaunchAppContinueLoginType;

export type LaunchAppType = {
  readonly __typename?: 'LaunchAppType';
  readonly authorizeUrl: Scalars['String'];
};

export type MeetingDirectJoinLinkType = {
  readonly __typename?: 'MeetingDirectJoinLinkType';
  readonly meetingDirectJoinLink: Scalars['String'];
};


export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly getMeetingDirectJoinLink?: Maybe<MeetingDirectJoinLinkType>;
  readonly getTeamsMeetingJoinLink?: Maybe<TeamsMeetingJoinLinkType>;
  readonly sendSMSDirectJoinLinkToPatient?: Maybe<PatientsSmsNotificationStatusTypeUnionResult>;
};


export type MutationGetMeetingDirectJoinLinkArgs = {
  sessionId: Scalars['String'];
  appointmentId: Scalars['String'];
};


export type MutationGetTeamsMeetingJoinLinkArgs = {
  sessionId: Scalars['String'];
  timeZoneOffset: Scalars['String'];
  appointmentId: Scalars['String'];
};


export type MutationSendSmsDirectJoinLinkToPatientArgs = {
  phoneNumber: Scalars['String'];
  sessionId: Scalars['String'];
  appointmentId: Scalars['String'];
};

export enum NotificationDeliveryStatus {
  Unknown = 'UNKNOWN',
  Pending = 'PENDING',
  Sent = 'SENT',
  Failed = 'FAILED',
  Delivered = 'DELIVERED',
  UnDelivered = 'UN_DELIVERED'
}

export type PatientInfoType = {
  readonly __typename?: 'PatientInfoType';
  readonly id: Scalars['String'];
  readonly name: Scalars['String'];
  readonly appointmentDetailsList: ReadonlyArray<AppointmentDetailType>;
};

export type PatientsSmsNotificationStatusLimitReachedType = {
  readonly __typename?: 'PatientsSMSNotificationStatusLimitReachedType';
  readonly id: Scalars['String'];
  readonly limit: Scalars['String'];
};

export type PatientsSmsNotificationStatusType = {
  readonly __typename?: 'PatientsSMSNotificationStatusType';
  readonly deliveryStatus?: Maybe<NotificationDeliveryStatus>;
  readonly error?: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly lastActionTime?: Maybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly phoneNumber?: Maybe<Scalars['String']>;
};

export type PatientsSmsNotificationStatusTypeUnionResult = PatientsSmsNotificationStatusType | PatientsSmsNotificationStatusLimitReachedType;

export type Query = {
  readonly __typename?: 'Query';
  readonly getAppointmentInfo?: Maybe<AppointmentInfoType>;
  readonly getAriaIngestionKey?: Maybe<Scalars['String']>;
  readonly getPatientInfo?: Maybe<PatientInfoType>;
  readonly getPatientsSMSNotificationStatus?: Maybe<PatientsSmsNotificationStatusType>;
  readonly launchApp?: Maybe<LaunchAppType>;
  readonly launchAppContinue?: Maybe<LaunchAppContinueTypeUnionResult>;
  readonly launchAppContinueAAD?: Maybe<LaunchAppContinueAadType>;
};


export type QueryGetAppointmentInfoArgs = {
  sessionId: Scalars['String'];
  appointmentId: Scalars['String'];
};


export type QueryGetPatientInfoArgs = {
  sessionId: Scalars['String'];
};


export type QueryGetPatientsSmsNotificationStatusArgs = {
  sessionId: Scalars['String'];
  appointmentId: Scalars['String'];
};


export type QueryLaunchAppArgs = {
  iss: Scalars['String'];
  launch: Scalars['String'];
};


export type QueryLaunchAppContinueArgs = {
  code: Scalars['String'];
  state: Scalars['String'];
};


export type QueryLaunchAppContinueAadArgs = {
  code: Scalars['String'];
  state: Scalars['String'];
};


export type TeamsMeetingJoinLinkType = {
  readonly __typename?: 'TeamsMeetingJoinLinkType';
  readonly teamsMeetingJoinLink: Scalars['String'];
};

export type PatientsSmsNotificationStatusFieldsFragment = (
  { readonly __typename?: 'PatientsSMSNotificationStatusType' }
  & Pick<PatientsSmsNotificationStatusType, 'id' | 'name' | 'phoneNumber' | 'deliveryStatus' | 'lastActionTime' | 'error'>
);

export type GetMeetingDirectJoinLinkMutationVariables = Exact<{
  sessionId: Scalars['String'];
  appointmentId: Scalars['String'];
}>;


export type GetMeetingDirectJoinLinkMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly getMeetingDirectJoinLink?: Maybe<(
    { readonly __typename?: 'MeetingDirectJoinLinkType' }
    & Pick<MeetingDirectJoinLinkType, 'meetingDirectJoinLink'>
  )> }
);

export type GetTeamsMeetingJoinLinkMutationVariables = Exact<{
  sessionId: Scalars['String'];
  timeZoneOffset: Scalars['String'];
  appointmentId: Scalars['String'];
}>;


export type GetTeamsMeetingJoinLinkMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly getTeamsMeetingJoinLink?: Maybe<(
    { readonly __typename?: 'TeamsMeetingJoinLinkType' }
    & Pick<TeamsMeetingJoinLinkType, 'teamsMeetingJoinLink'>
  )> }
);

export type SendSmsDirectJoinLinkToPatientMutationVariables = Exact<{
  sessionId: Scalars['String'];
  phoneNumber: Scalars['String'];
  appointmentId: Scalars['String'];
}>;


export type SendSmsDirectJoinLinkToPatientMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly sendSMSDirectJoinLinkToPatient?: Maybe<(
    { readonly __typename: 'PatientsSMSNotificationStatusType' }
    & PatientsSmsNotificationStatusFieldsFragment
  ) | (
    { readonly __typename: 'PatientsSMSNotificationStatusLimitReachedType' }
    & Pick<PatientsSmsNotificationStatusLimitReachedType, 'id' | 'limit'>
  )> }
);

export type GetAppointmentInfoQueryVariables = Exact<{
  sessionId: Scalars['String'];
  appointmentId: Scalars['String'];
}>;


export type GetAppointmentInfoQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getAppointmentInfo?: Maybe<(
    { readonly __typename?: 'AppointmentInfoType' }
    & Pick<AppointmentInfoType, 'serviceType' | 'status' | 'startTime' | 'durationInMinutes' | 'patientWaitTimeInSeconds'>
  )> }
);

export type GetAriaIngestionKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAriaIngestionKeyQuery = (
  { readonly __typename?: 'Query' }
  & Pick<Query, 'getAriaIngestionKey'>
);

export type GetPatientInfoQueryVariables = Exact<{
  sessionId: Scalars['String'];
}>;


export type GetPatientInfoQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getPatientInfo?: Maybe<(
    { readonly __typename?: 'PatientInfoType' }
    & Pick<PatientInfoType, 'name'>
    & { readonly appointmentDetailsList: ReadonlyArray<(
      { readonly __typename?: 'AppointmentDetailType' }
      & Pick<AppointmentDetailType, 'id' | 'startTime'>
    )> }
  )> }
);

export type GetPatientsSmsNotificationStatusQueryVariables = Exact<{
  sessionId: Scalars['String'];
  appointmentId: Scalars['String'];
}>;


export type GetPatientsSmsNotificationStatusQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getPatientsSMSNotificationStatus?: Maybe<(
    { readonly __typename?: 'PatientsSMSNotificationStatusType' }
    & PatientsSmsNotificationStatusFieldsFragment
  )> }
);

export type LaunchAppQueryVariables = Exact<{
  iss: Scalars['String'];
  launch: Scalars['String'];
}>;


export type LaunchAppQuery = (
  { readonly __typename?: 'Query' }
  & { readonly launchApp?: Maybe<(
    { readonly __typename?: 'LaunchAppType' }
    & Pick<LaunchAppType, 'authorizeUrl'>
  )> }
);

export type LaunchAppContinueQueryVariables = Exact<{
  code: Scalars['String'];
  state: Scalars['String'];
}>;


export type LaunchAppContinueQuery = (
  { readonly __typename?: 'Query' }
  & { readonly launchAppContinue?: Maybe<(
    { readonly __typename?: 'LaunchAppContinueType' }
    & Pick<LaunchAppContinueType, 'sessionId'>
  ) | (
    { readonly __typename?: 'LaunchAppContinueLoginType' }
    & Pick<LaunchAppContinueLoginType, 'm365LoginUrl'>
  )> }
);

export type LaunchAppContinueAadQueryVariables = Exact<{
  state: Scalars['String'];
  code: Scalars['String'];
}>;


export type LaunchAppContinueAadQuery = (
  { readonly __typename?: 'Query' }
  & { readonly launchAppContinueAAD?: Maybe<(
    { readonly __typename?: 'LaunchAppContinueAadType' }
    & Pick<LaunchAppContinueAadType, 'sessionId'>
  )> }
);

export const PatientsSmsNotificationStatusFieldsFragmentDoc = gql`
    fragment PatientsSMSNotificationStatusFields on PatientsSMSNotificationStatusType {
  id
  name
  phoneNumber
  deliveryStatus
  lastActionTime
  error
}
    `;
export const GetMeetingDirectJoinLinkDocument = gql`
    mutation GetMeetingDirectJoinLink($sessionId: String!, $appointmentId: String!) {
  getMeetingDirectJoinLink(sessionId: $sessionId, appointmentId: $appointmentId) {
    meetingDirectJoinLink
  }
}
    `;
export type GetMeetingDirectJoinLinkMutationFn = ApolloReactCommon.MutationFunction<GetMeetingDirectJoinLinkMutation, GetMeetingDirectJoinLinkMutationVariables>;

/**
 * __useGetMeetingDirectJoinLinkMutation__
 *
 * To run a mutation, you first call `useGetMeetingDirectJoinLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetMeetingDirectJoinLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getMeetingDirectJoinLinkMutation, { data, loading, error }] = useGetMeetingDirectJoinLinkMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetMeetingDirectJoinLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GetMeetingDirectJoinLinkMutation, GetMeetingDirectJoinLinkMutationVariables>) {
        return ApolloReactHooks.useMutation<GetMeetingDirectJoinLinkMutation, GetMeetingDirectJoinLinkMutationVariables>(GetMeetingDirectJoinLinkDocument, baseOptions);
      }
export type GetMeetingDirectJoinLinkMutationHookResult = ReturnType<typeof useGetMeetingDirectJoinLinkMutation>;
export type GetMeetingDirectJoinLinkMutationResult = ApolloReactCommon.MutationResult<GetMeetingDirectJoinLinkMutation>;
export type GetMeetingDirectJoinLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<GetMeetingDirectJoinLinkMutation, GetMeetingDirectJoinLinkMutationVariables>;
export const GetTeamsMeetingJoinLinkDocument = gql`
    mutation GetTeamsMeetingJoinLink($sessionId: String!, $timeZoneOffset: String!, $appointmentId: String!) {
  getTeamsMeetingJoinLink(
    sessionId: $sessionId
    timeZoneOffset: $timeZoneOffset
    appointmentId: $appointmentId
  ) {
    teamsMeetingJoinLink
  }
}
    `;
export type GetTeamsMeetingJoinLinkMutationFn = ApolloReactCommon.MutationFunction<GetTeamsMeetingJoinLinkMutation, GetTeamsMeetingJoinLinkMutationVariables>;

/**
 * __useGetTeamsMeetingJoinLinkMutation__
 *
 * To run a mutation, you first call `useGetTeamsMeetingJoinLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsMeetingJoinLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getTeamsMeetingJoinLinkMutation, { data, loading, error }] = useGetTeamsMeetingJoinLinkMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      timeZoneOffset: // value for 'timeZoneOffset'
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetTeamsMeetingJoinLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GetTeamsMeetingJoinLinkMutation, GetTeamsMeetingJoinLinkMutationVariables>) {
        return ApolloReactHooks.useMutation<GetTeamsMeetingJoinLinkMutation, GetTeamsMeetingJoinLinkMutationVariables>(GetTeamsMeetingJoinLinkDocument, baseOptions);
      }
export type GetTeamsMeetingJoinLinkMutationHookResult = ReturnType<typeof useGetTeamsMeetingJoinLinkMutation>;
export type GetTeamsMeetingJoinLinkMutationResult = ApolloReactCommon.MutationResult<GetTeamsMeetingJoinLinkMutation>;
export type GetTeamsMeetingJoinLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<GetTeamsMeetingJoinLinkMutation, GetTeamsMeetingJoinLinkMutationVariables>;
export const SendSmsDirectJoinLinkToPatientDocument = gql`
    mutation SendSMSDirectJoinLinkToPatient($sessionId: String!, $phoneNumber: String!, $appointmentId: String!) {
  sendSMSDirectJoinLinkToPatient(
    sessionId: $sessionId
    phoneNumber: $phoneNumber
    appointmentId: $appointmentId
  ) {
    __typename
    ... on PatientsSMSNotificationStatusType {
      ...PatientsSMSNotificationStatusFields
    }
    ... on PatientsSMSNotificationStatusLimitReachedType {
      id
      limit
    }
  }
}
    ${PatientsSmsNotificationStatusFieldsFragmentDoc}`;
export type SendSmsDirectJoinLinkToPatientMutationFn = ApolloReactCommon.MutationFunction<SendSmsDirectJoinLinkToPatientMutation, SendSmsDirectJoinLinkToPatientMutationVariables>;

/**
 * __useSendSmsDirectJoinLinkToPatientMutation__
 *
 * To run a mutation, you first call `useSendSmsDirectJoinLinkToPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSmsDirectJoinLinkToPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSmsDirectJoinLinkToPatientMutation, { data, loading, error }] = useSendSmsDirectJoinLinkToPatientMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      phoneNumber: // value for 'phoneNumber'
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useSendSmsDirectJoinLinkToPatientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendSmsDirectJoinLinkToPatientMutation, SendSmsDirectJoinLinkToPatientMutationVariables>) {
        return ApolloReactHooks.useMutation<SendSmsDirectJoinLinkToPatientMutation, SendSmsDirectJoinLinkToPatientMutationVariables>(SendSmsDirectJoinLinkToPatientDocument, baseOptions);
      }
export type SendSmsDirectJoinLinkToPatientMutationHookResult = ReturnType<typeof useSendSmsDirectJoinLinkToPatientMutation>;
export type SendSmsDirectJoinLinkToPatientMutationResult = ApolloReactCommon.MutationResult<SendSmsDirectJoinLinkToPatientMutation>;
export type SendSmsDirectJoinLinkToPatientMutationOptions = ApolloReactCommon.BaseMutationOptions<SendSmsDirectJoinLinkToPatientMutation, SendSmsDirectJoinLinkToPatientMutationVariables>;
export const GetAppointmentInfoDocument = gql`
    query GetAppointmentInfo($sessionId: String!, $appointmentId: String!) {
  getAppointmentInfo(sessionId: $sessionId, appointmentId: $appointmentId) {
    serviceType
    status
    startTime
    durationInMinutes
    patientWaitTimeInSeconds
  }
}
    `;

/**
 * __useGetAppointmentInfoQuery__
 *
 * To run a query within a React component, call `useGetAppointmentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentInfoQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetAppointmentInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAppointmentInfoQuery, GetAppointmentInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAppointmentInfoQuery, GetAppointmentInfoQueryVariables>(GetAppointmentInfoDocument, baseOptions);
      }
export function useGetAppointmentInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAppointmentInfoQuery, GetAppointmentInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAppointmentInfoQuery, GetAppointmentInfoQueryVariables>(GetAppointmentInfoDocument, baseOptions);
        }
export type GetAppointmentInfoQueryHookResult = ReturnType<typeof useGetAppointmentInfoQuery>;
export type GetAppointmentInfoLazyQueryHookResult = ReturnType<typeof useGetAppointmentInfoLazyQuery>;
export type GetAppointmentInfoQueryResult = ApolloReactCommon.QueryResult<GetAppointmentInfoQuery, GetAppointmentInfoQueryVariables>;
export const GetAriaIngestionKeyDocument = gql`
    query GetAriaIngestionKey {
  getAriaIngestionKey
}
    `;

/**
 * __useGetAriaIngestionKeyQuery__
 *
 * To run a query within a React component, call `useGetAriaIngestionKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAriaIngestionKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAriaIngestionKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAriaIngestionKeyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAriaIngestionKeyQuery, GetAriaIngestionKeyQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAriaIngestionKeyQuery, GetAriaIngestionKeyQueryVariables>(GetAriaIngestionKeyDocument, baseOptions);
      }
export function useGetAriaIngestionKeyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAriaIngestionKeyQuery, GetAriaIngestionKeyQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAriaIngestionKeyQuery, GetAriaIngestionKeyQueryVariables>(GetAriaIngestionKeyDocument, baseOptions);
        }
export type GetAriaIngestionKeyQueryHookResult = ReturnType<typeof useGetAriaIngestionKeyQuery>;
export type GetAriaIngestionKeyLazyQueryHookResult = ReturnType<typeof useGetAriaIngestionKeyLazyQuery>;
export type GetAriaIngestionKeyQueryResult = ApolloReactCommon.QueryResult<GetAriaIngestionKeyQuery, GetAriaIngestionKeyQueryVariables>;
export const GetPatientInfoDocument = gql`
    query GetPatientInfo($sessionId: String!) {
  getPatientInfo(sessionId: $sessionId) {
    name
    appointmentDetailsList {
      id
      startTime
    }
  }
}
    `;

/**
 * __useGetPatientInfoQuery__
 *
 * To run a query within a React component, call `useGetPatientInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientInfoQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetPatientInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPatientInfoQuery, GetPatientInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPatientInfoQuery, GetPatientInfoQueryVariables>(GetPatientInfoDocument, baseOptions);
      }
export function useGetPatientInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPatientInfoQuery, GetPatientInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPatientInfoQuery, GetPatientInfoQueryVariables>(GetPatientInfoDocument, baseOptions);
        }
export type GetPatientInfoQueryHookResult = ReturnType<typeof useGetPatientInfoQuery>;
export type GetPatientInfoLazyQueryHookResult = ReturnType<typeof useGetPatientInfoLazyQuery>;
export type GetPatientInfoQueryResult = ApolloReactCommon.QueryResult<GetPatientInfoQuery, GetPatientInfoQueryVariables>;
export const GetPatientsSmsNotificationStatusDocument = gql`
    query GetPatientsSMSNotificationStatus($sessionId: String!, $appointmentId: String!) {
  getPatientsSMSNotificationStatus(
    sessionId: $sessionId
    appointmentId: $appointmentId
  ) {
    ...PatientsSMSNotificationStatusFields
  }
}
    ${PatientsSmsNotificationStatusFieldsFragmentDoc}`;

/**
 * __useGetPatientsSmsNotificationStatusQuery__
 *
 * To run a query within a React component, call `useGetPatientsSmsNotificationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientsSmsNotificationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientsSmsNotificationStatusQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useGetPatientsSmsNotificationStatusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPatientsSmsNotificationStatusQuery, GetPatientsSmsNotificationStatusQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPatientsSmsNotificationStatusQuery, GetPatientsSmsNotificationStatusQueryVariables>(GetPatientsSmsNotificationStatusDocument, baseOptions);
      }
export function useGetPatientsSmsNotificationStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPatientsSmsNotificationStatusQuery, GetPatientsSmsNotificationStatusQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPatientsSmsNotificationStatusQuery, GetPatientsSmsNotificationStatusQueryVariables>(GetPatientsSmsNotificationStatusDocument, baseOptions);
        }
export type GetPatientsSmsNotificationStatusQueryHookResult = ReturnType<typeof useGetPatientsSmsNotificationStatusQuery>;
export type GetPatientsSmsNotificationStatusLazyQueryHookResult = ReturnType<typeof useGetPatientsSmsNotificationStatusLazyQuery>;
export type GetPatientsSmsNotificationStatusQueryResult = ApolloReactCommon.QueryResult<GetPatientsSmsNotificationStatusQuery, GetPatientsSmsNotificationStatusQueryVariables>;
export const LaunchAppDocument = gql`
    query LaunchApp($iss: String!, $launch: String!) {
  launchApp(iss: $iss, launch: $launch) {
    authorizeUrl
  }
}
    `;

/**
 * __useLaunchAppQuery__
 *
 * To run a query within a React component, call `useLaunchAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchAppQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchAppQuery({
 *   variables: {
 *      iss: // value for 'iss'
 *      launch: // value for 'launch'
 *   },
 * });
 */
export function useLaunchAppQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LaunchAppQuery, LaunchAppQueryVariables>) {
        return ApolloReactHooks.useQuery<LaunchAppQuery, LaunchAppQueryVariables>(LaunchAppDocument, baseOptions);
      }
export function useLaunchAppLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LaunchAppQuery, LaunchAppQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LaunchAppQuery, LaunchAppQueryVariables>(LaunchAppDocument, baseOptions);
        }
export type LaunchAppQueryHookResult = ReturnType<typeof useLaunchAppQuery>;
export type LaunchAppLazyQueryHookResult = ReturnType<typeof useLaunchAppLazyQuery>;
export type LaunchAppQueryResult = ApolloReactCommon.QueryResult<LaunchAppQuery, LaunchAppQueryVariables>;
export const LaunchAppContinueDocument = gql`
    query LaunchAppContinue($code: String!, $state: String!) {
  launchAppContinue(code: $code, state: $state) {
    ... on LaunchAppContinueType {
      sessionId
    }
    ... on LaunchAppContinueLoginType {
      m365LoginUrl
    }
  }
}
    `;

/**
 * __useLaunchAppContinueQuery__
 *
 * To run a query within a React component, call `useLaunchAppContinueQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchAppContinueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchAppContinueQuery({
 *   variables: {
 *      code: // value for 'code'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useLaunchAppContinueQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LaunchAppContinueQuery, LaunchAppContinueQueryVariables>) {
        return ApolloReactHooks.useQuery<LaunchAppContinueQuery, LaunchAppContinueQueryVariables>(LaunchAppContinueDocument, baseOptions);
      }
export function useLaunchAppContinueLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LaunchAppContinueQuery, LaunchAppContinueQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LaunchAppContinueQuery, LaunchAppContinueQueryVariables>(LaunchAppContinueDocument, baseOptions);
        }
export type LaunchAppContinueQueryHookResult = ReturnType<typeof useLaunchAppContinueQuery>;
export type LaunchAppContinueLazyQueryHookResult = ReturnType<typeof useLaunchAppContinueLazyQuery>;
export type LaunchAppContinueQueryResult = ApolloReactCommon.QueryResult<LaunchAppContinueQuery, LaunchAppContinueQueryVariables>;
export const LaunchAppContinueAadDocument = gql`
    query LaunchAppContinueAAD($state: String!, $code: String!) {
  launchAppContinueAAD(state: $state, code: $code) {
    sessionId
  }
}
    `;

/**
 * __useLaunchAppContinueAadQuery__
 *
 * To run a query within a React component, call `useLaunchAppContinueAadQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchAppContinueAadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchAppContinueAadQuery({
 *   variables: {
 *      state: // value for 'state'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useLaunchAppContinueAadQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LaunchAppContinueAadQuery, LaunchAppContinueAadQueryVariables>) {
        return ApolloReactHooks.useQuery<LaunchAppContinueAadQuery, LaunchAppContinueAadQueryVariables>(LaunchAppContinueAadDocument, baseOptions);
      }
export function useLaunchAppContinueAadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LaunchAppContinueAadQuery, LaunchAppContinueAadQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LaunchAppContinueAadQuery, LaunchAppContinueAadQueryVariables>(LaunchAppContinueAadDocument, baseOptions);
        }
export type LaunchAppContinueAadQueryHookResult = ReturnType<typeof useLaunchAppContinueAadQuery>;
export type LaunchAppContinueAadLazyQueryHookResult = ReturnType<typeof useLaunchAppContinueAadLazyQuery>;
export type LaunchAppContinueAadQueryResult = ApolloReactCommon.QueryResult<LaunchAppContinueAadQuery, LaunchAppContinueAadQueryVariables>;